'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.default = function () {
  if (_store2.default.state.langList.length) return _promise2.default.resolve(_store2.default.state.langList);
  return (0, _axios2.default)({
    url: '/api-basic/portal/open/locale/getSupportLanguage',
    method: 'GET',
    data: {}
  }).then(function (_ref) {
    var data = _ref.data;

    var langList = data.data.map(function (item) {
      return {
        'label': item.country,
        'value': item.language
      };
    });
    console.log(langList);
    _store2.default.commit('LANGLIST', langList);
  });
};

var _store = require('@/store');

var _store2 = _interopRequireDefault(_store);

var _axios = require('@/plugins/axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }